import React from 'react';
import MuiSelect, { type SelectProps } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

interface Props extends SelectProps {
  readonly items: SelectOption[];
}

export interface SelectOption {
  name: string;
  id: string;
}

export default function BasicSelect({ items, ...props }: Props) {
  return (
    <MuiSelect
      displayEmpty
      data-testid="select-input"
      id={`select-${props.id}`}
      {...props}
    >
      {items.map((item) => (
        <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
      ))}
    </MuiSelect>
  );
}
